import instance from "./instance";

const responseData = response => response.data;

export function uploadCensus(
    quoteId,
    employerId,
    guid,
    fileData,
    census,
    currentMedicalBasePlanId,
    currentMedicalMappedPlans = [],
    currentPlansRateType = null,
    currentPlans = [],
) {
    if (fileData) {
        const formData = new FormData();
        if (quoteId) {
            formData.append("quoteId", quoteId);
        }
        if (employerId) {
            formData.append("employerId", employerId);
        }
        if (guid) {
            formData.append("guid", guid);
        }
        formData.append("file", fileData);

        return instance
            .request({
                url: "/census/upload-census",
                method: "POST",
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then(responseData);
    } else {
        return instance
            .request({
                url: "/census/upload-manual-census",
                method: "POST",
                data: {
                    census,
                    currentMedicalBasePlanId,
                    currentMedicalMappedPlans,
                    currentPlansRateType,
                    currentPlans,
                },
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then(responseData);
    }
}

export function copyCensus(fromQuoteId, toQuoteId, toGuid) {
    return instance
        .request({
            url: "/census/copy-census",
            method: "POST",
            data: {
                fromQuoteId,
                toQuoteId,
                toGuid,
            },
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then(responseData);
}

export function copyCensusU(fromId, toQuoteId) {
    return instance
        .request({
            url: "/census/copy-census-ubenefit",
            method: "POST",
            data: {
                fromId,
                toQuoteId,
            },
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then(responseData);
}

export function saveCensusMapping(census) {
    return instance.request({
        url: "/census/save-census-mapping",
        method: "POST",
        data: { census },
        headers: {
            "Content-Type": "application/json",
        },
    });
}

export function getCensusUniqueIdsByEmployerId(employerId) {
    return instance
        .request({
            url: `/census/get-census-uniqueids-by-employer/${employerId}`,
            method: "GET",
        })
        .then(responseData);
}

export function getCensusByQuoteId(quoteId) {
    return instance
        .request({
            url: `/census/get-census-by-quote/${quoteId}`,
            method: "GET",
        })
        .then(responseData);
}

export function getCensusByUniqueId(employerId, uniqueId) {
    return instance
        .request({
            url: `/census/get-census-by-employer/${employerId}/${uniqueId}`,
            method: "GET",
        })
        .then(responseData);
}

export function getCensusExtract(id) {
    return instance
        .request({
            url: `/census/get-census-extract/${id}`,
            method: "POST",
            responseType: "blob",
        })
        .then(response => {
            if (response.data && response.data.size > 0) {
                if (response.data.type.startsWith("application")) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "RatingHub_Census_For_Quote_" + id + ".xlsx");
                    document.body.appendChild(link);
                    link.click();
                } else if (response.data.type === "text/plain") {
                    return response.data.text();
                }
            } else {
                return "ERROR";
            }
        });
}

export function newHireWorksheet(payload) {
    return instance
        .request({
            url: "/census/get-new-hire-worksheet",
            method: "POST",
            data: { ...payload },
            headers: {
                "Content-Type": "application/json",
            },
            responseType: "blob",
        })
        .then(response => {
            if (response.data && response.data.size > 0) {
                if (response.data.type.startsWith("application")) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    const safeName = (payload.employerName || "").replace(/[^a-zA-Z0-9_-]/g, "_");
                    link.href = url;
                    link.setAttribute(
                        "download",
                        `RatingHub_New_Hire_Worksheet_${safeName}_${payload.employerID}.zip`,
                    );
                    document.body.appendChild(link);
                    link.click();
                } else if (response.data.type === "text/plain") {
                    return response.data.text();
                }
            } else {
                return "ERROR";
            }
        })
        .catch(err => {
            return "ERROR: " + err.message;
        });
}

export function getNewHireSettings(employerId, groupRenewalDate) {
    return instance
        .request({
            url: "/census/get-new-hire-settings",
            method: "POST",
            data: { employerID: employerId, groupRenewalDate: groupRenewalDate },
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then(responseData);
}

export function saveNewHireSettings(newHireSettings) {
    return instance
        .request({
            url: "/census/save-new-hire-settings",
            method: "POST",
            data: { ...newHireSettings },
        })
        .then(responseData);
}
